"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useHasUnreadMessages = void 0;
var react_1 = __importDefault(require("react"));
var use_chat_driver_1 = require("./use-chat-driver");
function useHasUnreadMessages() {
    var chatDriver = react_1["default"].useContext(use_chat_driver_1.ChatDriverContext);
    if (chatDriver == null) {
        throw new Error('ChatDriverContext not found');
    }
    var lastRead = (0, use_chat_driver_1.useEmittedDataSource)(function (chatDriver) { return chatDriver.lastRead; }, "changed/lastRead", chatDriver);
    return react_1["default"].useMemo(function () {
        var lastRead = chatDriver.lastRead;
        return lastRead !== null && chatDriver.chatSessionCreated > lastRead && chatDriver.groupedMessages.filter(function (m) { return m.message.sentDate < chatDriver.chatSessionCreated && m.message.sentDate > lastRead; }).length > 0;
    }, [
        lastRead,
        chatDriver.chatSessionCreated,
        chatDriver.groupedMessages
    ]);
}
exports.useHasUnreadMessages = useHasUnreadMessages;
